import { FlyerCategory } from '@/types/flyer';
import { BodyMediumMidEmphasis } from '@/design-system';
import styles from './FlyerCategoryCard.styles';
import { AccessibleDivButton } from '@/components';

interface FlyerCategoryCardProps {
  category: FlyerCategory;
  onClick: (category: FlyerCategory) => void;
}

const FlyerCategoryCard: React.FC<FlyerCategoryCardProps> = ({ category, onClick }) => (
  <AccessibleDivButton
    className={styles.container}
    onClick={() => onClick(category)}
    data-testid="categoryCard"
  >
    <div className={styles.card}>
      <div className={styles.icon}>
        <img
          src={category.icon}
          className={styles.iconShadow}
          alt="Category icon"
          data-testid="categoryCardIcon"
        />
      </div>
    </div>

    <div className={styles.title}>
      <BodyMediumMidEmphasis data-testid="categoryCardTitle">
        {category.title}
      </BodyMediumMidEmphasis>
    </div>
  </AccessibleDivButton>
);

export default FlyerCategoryCard;
